module.exports = __webpack_public_path__ + "img/project-edu-07.f42624f9.png";